import { Components, Theme } from '@mui/material';

const MuiFormControlLabel: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      alignItems: 'center',
      margin: 0,
      '&:not(.MuiFormControlLabel-labelPlacementStart) .MuiCheckbox-sizeSmall':
        {
          marginRight: theme.spacing(1.5),
        },
    }),
  },
};

export default MuiFormControlLabel;
